import React, { useEffect } from 'react';
import {useSearchParams} from "react-router-dom";
import {Cookies} from "fearless-common-ui";
import {Pages} from "../components/layout";
import {BackendForm, FloatingLabelField} from "../components/forms";
import {routes} from "../utils";
import useTitle from "../components/hooks/useTitle";


export default function TwoFactorChallenge() {
    const [searchParams] = useSearchParams();
    useTitle(`Two factor authentication`);
    useEffect(() => {
        // Need to be deleted, because otherwise Sanctum Guard will try to set the request's user
        // which will create the request user token using TransientToken, but we need it to use the
        // App\Model\PersonalAccessToken. See Laravel\Sanctum\Guard::__invoke method.
        Cookies.remove('XSRF-TOKEN');
        Cookies.remove('fearless_league_session');
    }, []);

    return (
        <Pages.Centred width="xs">
            <BackendForm
                targetMethod="POST"
                targetEndpoint="/two-factor-challenge-custom"
                onSuccess={() => {
                    // Hard refresh such that some global state (regarding auth cookies) is correctly initialised.
                    window.location.href = searchParams.get('redirect') || routes.landing;
                }}
                initialValues={{
                    code: '',
                }}
                onError={({ status }: { status: number }) => {
                    // If the user takes too long, the token expires and the user must be redirected to login again
                    if (status === 401) {
                        window.location.href = routes.login;
                    }
                }}
                config={{
                    withCredentials: false,
                }}
                showFooter={false}
            >
                <h2>Confirm it's you</h2>
                <p>
                    Open the two-factor authenticator (TOTP) app on your mobile device to view your <b>authentication code</b>.
                    You can also use one of your <b>recovery codes</b>.
                </p>
                <FloatingLabelField name="code" label="Authentication code" />
                <BackendForm.Footer showError />
            </BackendForm>
        </Pages.Centred>
    );
}


TwoFactorChallenge.propTypes = {
};
TwoFactorChallenge.defaultProps = {

};
